module.exports = __webpack_public_path__ + "static/img/b2.494ad09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/b2.png
// module id = xwiN
// module chunks = 1